import React, { useState } from 'react';
import SponsorSearch from './sponsor_search';
import SponsorOption from './sponsor_option';

const EventSponsorEdit = ({ sponsors }) => {
  const [allSponsors, setAllSponsors] = useState(sponsors);

  const handleSponsorSelect = (selectedSponsor) => {
    // Check if the selected sponsor ID already exists in the set of unique IDs
    if (!new Set(allSponsors.map(sponsor => sponsor.id)).has(selectedSponsor.id)) {
      setAllSponsors([...allSponsors, selectedSponsor]);
    }
  };

  const handleSponsorRemoval = (sponsorId) => {
    setAllSponsors(allSponsors.filter(sponsor => sponsor.id !== sponsorId));
  };

  return (
    <div>
      <SponsorSearch onSponsorSelect={handleSponsorSelect}/>
      {allSponsors.map((sponsor, index) => (
        <SponsorOption
          key={sponsor.id}
          name={sponsor.name}
          id={sponsor.id}
          imageUrl={sponsor.image_url}
          imageAlt={sponsor.image_alt}
          handleSponsorRemoval={handleSponsorRemoval}
          index={index}
        />
      ))}
    </div>
  );
};

export default EventSponsorEdit;
